var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailPlane1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 64,
    viewBox: "0 0 69 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.984 28.2423L42.5952 7.88751L47.7302 31.2009L39.984 28.2423Z",
    fill: "#0CF2DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7705 23.1859L42.5953 7.88806L39.9841 28.2428L44.8364 61.1075L24.7705 23.1859Z",
    fill: "#B9DAF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8363 61.108L39.9839 28.2432L47.7301 31.2019L62.8973 36.9959L44.8363 61.108Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52938 17.2617L24.7704 23.186L44.8363 61.1076L8.52938 17.2617Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8363 61.1076L39.984 28.2429L42.5952 7.88815L24.7704 23.186L8.52938 17.2617L44.8363 61.1076Z",
    stroke: "#29562A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7705 23.1859L44.8364 61.1075L62.8975 36.9955L47.7303 31.2015L39.9841 28.2428",
    stroke: "#29562A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5952 7.88751L47.7302 31.2009",
    stroke: "#29562A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailPlane1);
export default __webpack_public_path__ + "static/media/email-plane-1.74be88c5906bb10eb95fa63a73e4d5e9.svg";
export { ForwardRef as ReactComponent };